import { render, staticRenderFns } from "./conversation-row.vue?vue&type=template&id=2fbe65d8&scoped=true&"
import script from "./conversation-row.vue?vue&type=script&lang=js&"
export * from "./conversation-row.vue?vue&type=script&lang=js&"
import style0 from "./conversation-row.vue?vue&type=style&index=0&id=2fbe65d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe65d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fbe65d8')) {
      api.createRecord('2fbe65d8', component.options)
    } else {
      api.reload('2fbe65d8', component.options)
    }
    module.hot.accept("./conversation-row.vue?vue&type=template&id=2fbe65d8&scoped=true&", function () {
      api.rerender('2fbe65d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/conversation-row/conversation-row.vue"
export default component.exports